import { render, staticRenderFns } from "./CardGridDynamic.vue?vue&type=template&id=5cfc1206&scoped=true&"
import script from "./CardGridDynamic.vue?vue&type=script&lang=js&"
export * from "./CardGridDynamic.vue?vue&type=script&lang=js&"
import style0 from "./CardGridDynamic.vue?vue&type=style&index=0&id=5cfc1206&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfc1206",
  null
  
)

export default component.exports